import React from 'react';
import cx from 'classnames';

import {
  Border,
  Button,
  ButtonTooltip,
  PillDropDown,
  LoadingSpinner,
} from 'spindl-shared-components';

import ErrorIndicator from '../../molecules/ErrorIndicator';

import styles from './TemplateEditorSubNav.module.scss';
import usePresenter from './TemplateEditorSubNav.presenter';
import getProps from './TemplateEditorSubNav.props';
import { TemplateEditorSubNavCombinedProps } from './types';

const TemplateEditorSubNav: React.FC<TemplateEditorSubNavCombinedProps> = (props) => {
  const {
    error,
    styleType,
    className,
    classes,
    button,
    border,
    errorIndicator,
    pillDropDown,
    buttonTooltip,
    border1,
    saveButton,
    border2,
  } = usePresenter(props);

  const variantName = `${error}${styleType}`;
  const internalProps = getProps(variantName);
  const currentStyle = styles[`templateEditorSubNav${variantName}`];

  let componentView;

  switch (variantName) {
    case 'ErrorDefault': {
      componentView = (
        <div className={cx(currentStyle, className)}>
          <div className={cx(styles.subNavContent, classes?.subNavContent)}>
            <div className={cx(styles.leftContent, classes?.leftContent)}>
              <Button
                className={cx(styles.button, classes?.button)}
                {...internalProps.button}
                {...button}/>
              <Border
                className={cx(styles.border, classes?.border)}
                {...internalProps.border}
                {...border}/>
              <ErrorIndicator
                className={cx(styles.errorIndicator, classes?.errorIndicator)}
                {...internalProps.errorIndicator}
                {...errorIndicator}/>
            </div>
            <div className={cx(styles.centerContainer, classes?.centerContainer)}>
              <PillDropDown
                className={cx(styles.pillDropDown, classes?.pillDropDown)}
                {...internalProps.pillDropDown}
                {...pillDropDown}/>
            </div>
            <div className={cx(styles.rightContent, classes?.rightContent)}>
              <ButtonTooltip
                className={cx(styles.buttonTooltip, classes?.buttonTooltip)}
                {...internalProps.buttonTooltip}
                {...buttonTooltip}/>
              <Border
                className={cx(styles.border1, classes?.border1)}
                {...internalProps.border1}
                {...border1}/>
              <Button
                className={cx(styles.saveButton, classes?.saveButton)}
                {...internalProps.saveButton}
                {...saveButton}/>
            </div>
          </div>
          <Border
            className={cx(styles.border2, classes?.border2)}
            {...internalProps.border2}
            {...border2}/>
        </div>
      );
      break;
    }
    case 'NoneDefault': {
      componentView = (
        <div className={cx(currentStyle, className)}>
          <div className={cx(styles.subNavContent, classes?.subNavContent)}>
            <div className={cx(styles.leftContent, classes?.leftContent)}>
              <Button
                className={cx(styles.button, classes?.button)}
                {...internalProps.button}
                {...button}/>
            </div>
            <div className={cx(styles.centerContainer, classes?.centerContainer)}>
              <PillDropDown
                className={cx(styles.pillDropDown, classes?.pillDropDown)}
                {...internalProps.pillDropDown}
                {...pillDropDown}/>
            </div>
            <div className={cx(styles.rightContent, classes?.rightContent)}>
              <ButtonTooltip
                className={cx(styles.buttonTooltip, classes?.buttonTooltip)}
                {...internalProps.buttonTooltip}
                {...buttonTooltip}/>
              <Border
                className={cx(styles.border, classes?.border)}
                {...internalProps.border}
                {...border}/>
              <Button
                className={cx(styles.saveButton, classes?.saveButton)}
                {...internalProps.saveButton}
                {...saveButton}/>
            </div>
          </div>
          <Border
            className={cx(styles.border1, classes?.border1)}
            {...internalProps.border1}
            {...border1}/>
        </div>
      );
      break;
    }
    case 'NoneLoading': {
      componentView = (
        <div className={cx(currentStyle, className)}>
          <div className={cx(styles.subNavContent, classes?.subNavContent)}>
            <div className={cx(styles.leftContent, classes?.leftContent)}>
              <Button
                className={cx(styles.button, classes?.button)}
                {...internalProps.button}
                {...button}/>
              <Border
                className={cx(styles.border, classes?.border)}
                {...internalProps.border}
                {...border}/>

              <LoadingSpinner 
                className={cx(styles.loadingSpinner)}
                {...internalProps.loadingSpinner}
                isActive /> 
            </div>
            <div className={cx(styles.centerContainer, classes?.centerContainer)}>
              <PillDropDown
                className={cx(styles.pillDropDown, classes?.pillDropDown)}
                {...internalProps.pillDropDown}
                {...pillDropDown}/>
            </div>
            <div className={cx(styles.rightContent, classes?.rightContent)}>
              <ButtonTooltip
                className={cx(styles.buttonTooltip, classes?.buttonTooltip)}
                {...internalProps.buttonTooltip}
                {...buttonTooltip}/>
              <Border
                className={cx(styles.border1, classes?.border1)}
                {...internalProps.border1}
                {...border1}/>
              <Button
                className={cx(styles.saveButton, classes?.saveButton)}
                {...internalProps.saveButton}
                {...saveButton}/>
            </div>
          </div>
          <Border
            className={cx(styles.border2, classes?.border2)}
            {...internalProps.border2}
            {...border2}/>
        </div>
      );
      break;
    }
    default:
      componentView = <div>�</div>;
      break;
  }

  return componentView;
};

export default TemplateEditorSubNav;
